import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTG_JordanianGovernoratesName = createAsyncThunk(
  "dropdowns/GetAllTG_JordanianGovernoratesName",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTG_JordanianGovernoratesName"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListJordanianGovernorates = createAsyncThunk(
  "ListJordanianGovernorates/GetListJordanianGovernorates",
  async (tG_MainTargetedGroupId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TG_JordanianGovernoratesProjectActivities/GetTG_JordanianGovernoratesProjectActivitiesListData",
        {
          tG_MainTargetedGroupId: tG_MainTargetedGroupId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownJordanianGovernoratesName = createSlice({
  name: "DropDownJordanianGovernoratesName",
  initialState: {
    DropDownJordanianGovernoratesName: [],
    loadingDropDownJordanianGovernoratesName: false,
    errorDropDownJordanianGovernoratesName: null,
    JordanianGovernoratesList: [],
    loadingJordanianGovernoratesList: false,
    errorJordanianGovernoratesList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTG_JordanianGovernoratesName.pending, (state, action) => {
        state.loadingDropDownJordanianGovernoratesName = true;
        state.DropDownJordanianGovernoratesName = action.payload;
        state.errorDropDownJordanianGovernoratesName = null;
      })
      .addCase(
        GetAllTG_JordanianGovernoratesName.fulfilled,
        (state, action) => {
          state.loadingDropDownJordanianGovernoratesName = false;
          state.DropDownJordanianGovernoratesName = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetAllTG_JordanianGovernoratesName.rejected, (state, action) => {
        state.loadingDropDownJordanianGovernoratesName = false;
        state.errorDropDownJordanianGovernoratesName = action.payload;
      })
      .addCase(GetListJordanianGovernorates.pending, (state, action) => {
        state.loadingJordanianGovernoratesList = true;
        state.JordanianGovernoratesList = action.payload;
        state.errorJordanianGovernoratesList = null;
      })
      .addCase(GetListJordanianGovernorates.fulfilled, (state, action) => {
        state.loadingJordanianGovernoratesList = false;
        state.JordanianGovernoratesList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListJordanianGovernorates.rejected, (state, action) => {
        state.loadingJordanianGovernoratesList = false;
        state.errorJordanianGovernoratesList = action.payload;
      });
  },
});

export default DropDownJordanianGovernoratesName.reducer;
